import dotenv from 'dotenv';
dotenv.config();

export const getCultivo = () => {
    return (dispatch) => {
        dispatch({type: "CULTIVO_LOADING"});
        let headers = {"Content-Type": "application/json"};
        if(!!localStorage.getItem('token_cafe')){
            headers["Authorization"] = `Bearer ${localStorage.getItem('token_cafe')}`;
            return fetch(`${process.env.REACT_APP_API_URL}/cultivos/user`, {headers, method: "GET"}).then((res) => {
                if(res.status === 200){
                    res.json().then(res => {
                        dispatch({type: "CULTIVO_LOAD_SUCCESS", data: res.data});
                    }).catch(err => {
                        dispatch({type: "CULTIVO_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
                    });
                }else{
                    dispatch({type: "CULTIVO_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
                }
            }).catch((err) => {
                dispatch({type: "CULTIVO_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
            });
        }else{
            dispatch({type: "CULTIVO_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
        }
    }
};


